// extracted by mini-css-extract-plugin
export var wrapper = "homeBlockContent-module--wrapper--3-VIY";